import ApiService from './ApiService'

const InvoicesService = {
    generateInvoicesForContract(contract) {
        return ApiService.get('contract.invoices.generate', contract)
    },

    async downloadInvoice({ invoiceId, fileId, fileName }) {
        try {
            await ApiService.downloadFile('invoices.downloadFile', fileName, {
                invoice: invoiceId,
                file: fileId,
            })
        } catch (error) {
            console.error('Error downloading invoice:', error)
            throw error
        }
    },

    getInvoiceData(invoice) {
        return ApiService.get('invoices.show', invoice)
    },

    getBillingEntities() {
        return ApiService.get('invoices.billing_entities')
    },

    sendMultipleInvoices(invoices, doNotSendEmails = false) {
        return ApiService.post('invoices.send_multiple', {
            invoices,
            do_not_send_emails: doNotSendEmails,
        })
    },

    markMultipleInvoicesAsPaid(invoices) {
        return ApiService.post('invoices.mark_multiple_as_paid', { invoices })
    },

    markAsPaid(invoice) {
        return ApiService.get('invoices.markAsPaid', { invoice })
    },

    moveToNextStage(invoice, doNotSendEmails = false) {
        return ApiService.get('invoices.nextStage', {
            invoice,
            do_not_send_emails: doNotSendEmails ? 1 : 0,
        })
    },

    cancel(invoice) {
        return ApiService.get('invoices.cancel', { invoice })
    },
}

export default InvoicesService
